import { scoreWordCount } from './scoreWordCount'
import { calculateGenderScore } from './genderScore'

export const calculateAggregateScores = editorState => {
    const {
        maleCount,
        femaleCount,
        mustCount,
        countExperience,
        countEducation,
        readability,
        wordCount,
        countCorporate,
        capsCount,
    } = editorState
    const scores = {
        inclusion: {
            gender: {
                score: 100 * calculateGenderScore(maleCount, femaleCount),
            },
            musthaves: {
                score: 20 * (5 - Math.min(5, mustCount)),
            },
            inhibiting: {
                score: 20 * (5 - Math.min(5, countExperience)),
            },
            education: {
                score: (100 / 3) * (3 - Math.min(3, countEducation || 0)),
            },
            score: 0,
        },
        conversion: {
            readability: {
                score: Math.max(0, Math.min(100, readability)),
            },
            wordcount: {
                score: scoreWordCount(wordCount),
            },
            buzzwords: {
                score: (100 / 3) * (3 - Math.min(3, countCorporate)),
            },
            acronyms: {
                score: 10 * (10 - Math.min(10, capsCount)),
            },
            score: 0,
        },
    }
    scores.inclusion.score = Math.round(
        0.4 * scores.inclusion.gender.score +
            0.2 * scores.inclusion.musthaves.score +
            0.2 * scores.inclusion.inhibiting.score +
            0.2 * scores.inclusion.education.score,
    )

    scores.conversion.score = Math.round(
        0.3 * scores.conversion.readability.score +
            0.3 * scores.conversion.wordcount.score +
            0.2 * scores.conversion.buzzwords.score +
            0.2 * scores.conversion.acronyms.score,
    )
    return scores
}
